import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  question: 'Do you offer broken window repair near me?',
  answer: 'Kosin’s Glass serves Howell, Ann Arbor, Novi and many surrounding Southeast Michigan communities. Request a free in-home estimate and the team will confirm availability for your location and project.'
}, {
  question: 'Can you replace window glass only instead of the whole window?',
  answer: 'Yes, when the existing frame is still in good condition, glass-only replacement may be a smart option. Kosin’s Glass can inspect your window and explain whether repairing or replacing the glass makes sense.'
}, {
  question: 'Can you repair foggy double-pane windows?',
  answer: 'Fog or condensation between panes usually means an insulated glass seal has failed. Kosin’s Glass can inspect the window and recommend seal repair, insulated glass replacement or another appropriate solution.'
}, {
  question: 'What measurements do you need for a rough quote?',
  answer: 'For a rough quote, measure the visible glass width and height in inches and take a clear photo if possible. Kosin’s Glass will take exact measurements before ordering or installing replacement glass.'
}, {
  question: 'Do you replace door glass?',
  answer: 'Yes. Kosin’s Glass replaces entry door glass, patio door glass, storm door glass, decorative glass inserts and other residential door glass.'
}, {
  question: 'Do you install custom glass shower doors?',
  answer: 'Yes. Kosin’s Glass designs and installs custom glass shower doors and enclosures, including frameless, semi-frameless, sliding and Euro-style options.'
}, {
  question: 'Do you make custom mirrors?',
  answer: 'Yes. Kosin’s Glass can help with bathroom mirrors, vanity mirrors, home gym mirrors, wall mirrors, beveled mirrors, tinted mirrors, etched mirrors and custom-shaped mirrors.'
}, {
  question: 'Do you replace glass table tops and shelves?',
  answer: 'Yes. Kosin’s Glass can measure and fabricate custom glass table tops, shelves, cabinet glass, decorative glass and specialty residential glass.'
}, {
  question: 'Do you repair window screens and door screens?',
  answer: 'Yes. Kosin’s Glass can repair damaged window screens and door screens by replacing the screen material.'
}, {
  question: 'Is same-day residential glass service available?',
  answer: 'Same-day openings may be available depending on the glass type, project, schedule and whether materials are in stock. Request an estimate or call the Howell service center to check availability.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <div className="space-y-4" data-id="element-13">
      {FAQS.map((item, idx) => {
      const isOpen = openIdx === idx;
      const panelId = `faq-panel-${idx}`;
      const buttonId = `faq-button-${idx}`;
      return <div key={idx} className={`border rounded-xl transition-colors ${isOpen ? 'border-brandBlue-200 bg-brandBlue-50/30' : 'border-slate-200 bg-white'}`} data-id="element-14">
            <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-500 rounded-xl" data-id="element-15">
              <span className="text-lg font-bold text-navy-900 pr-8" dangerouslySetInnerHTML={{
            __html: item.question
          }} data-id="element-16" />
              <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brandBlue-600' : 'text-slate-400'}`} aria-hidden="true" data-id="element-17" />
            </button>

            {/* CSS-only expand using grid-template-rows 0fr -> 1fr */}
            <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-18">
              <div className="overflow-hidden" data-id="element-19">
                <div className="px-6 pb-6 text-slate-600 text-lg leading-relaxed" dangerouslySetInnerHTML={{
              __html: item.answer
            }} data-id="element-20" />
              </div>
            </div>
          </div>;
    })}
    </div>;
}